import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import { ramactions } from "../store/index";
import { useTranslation } from "react-i18next";

const Map = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "map" });
  const webLanguage = localStorage.getItem("lang");
  const place = useSelector((index) => index.place);
  const [totalphysical, setTotalphysical] = useState(0);
  const [resourcesmap, setResourcesmap] = useState();
  const [allmarkers, setAllmarkers] = useState([]);
  const dispatch = useDispatch();
  const [activeMarker, setActiveMarker] = useState(null);
  const rearchresults = useSelector((index) => index.rearchresults);
  const etlid = useSelector((index) => index.etlID);
  const zoomLevel = useSelector((index) => index.zoomLevel);
  const activeItem = useSelector((index) => index.activeItem);
  const google = window.google;
  useEffect(() => {
    const physical = rearchresults.filter(
      (index) => index.IsHelpline === false
    );
    setTotalphysical(physical.length);
    if (physical.length > 0) {
      window.initMap = () => {
        //console.log("MAP INIT");
        var latlng = new google.maps.LatLng("65.246292", "-110.116226");
        var bounds = new google.maps.LatLngBounds();
        var map = new google.maps.Map(document.getElementById("mapview"), {
          zoom: zoomLevel,
          minZoom: 3,
          maxZoom: 20,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          panControl: false,
          zoomControl: false,
          scaleControl: false,
          mapTypeControlOptions: {
            mapTypeIds: [],
          },
          // mapTypeId: MY_MAPTYPE_ID,
          disableDefaultUI: true,
          center: latlng,
        });
        map.setCenter(new google.maps.LatLng(place.latitude, place.longitude));
        setMarkers(map);
        //handleOnLoad(map);
        setResourcesmap(map);
      };
    }
  }, []);

  useEffect(() => {
    if (props.mapVisibility) {
      setMarkers(resourcesmap);
      resourcesmap.setZoom(15);
    }
  }, [props.mapVisibility]);

  useEffect(async () => {
    if (etlid.length > 0) {
      await clearAllMarkers();
      setMarkers(resourcesmap);
      const midpoint = {
        lat: activeItem.Latitude,
        lng: activeItem.Longitude,
      };
      resourcesmap.setCenter(midpoint);
      resourcesmap.setZoom(zoomLevel);
    }
  }, [activeItem]);

  const clearAllMarkers = async () => {
    allmarkers.forEach(function (marker) {
      marker.setMap(null);
    });
    setAllmarkers([]);
  };

  const setMarkers = async (map) => {
    //console.log("setting up!!");
    // Clear out the old markers.
    /*allmarkers.forEach(function (marker) {
      marker.setMap(null);
    });*/

    var markers = [];
    let i = 0;
    const bounds = new window.google.maps.LatLngBounds();
    rearchresults.forEach((index) => {
      /*if (i < 10) {
          bounds.extend({
            lat: parseFloat(index.Latitude),
            lng: parseFloat(index.Longitude),
          });
        }
        i = i + 1;*/

      //console.log("herere");
      const unselectedIcon =
        "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/map-pin-unselected.svg";
      const selectedIcon =
        "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/map-pin-selected.svg";

      let iconUrl = index.ETLLoadID === etlid ? selectedIcon : unselectedIcon;

      //console.log(iconUrl);

      if (index.Map != "list") {
        if (index.IsHelpline == false) {
          if (index.Latitude != "" && index.Longitude != "") {
            var lat = index.Latitude;
            var long = index.Longitude;

            var latlng = new google.maps.LatLng(lat, long);

            if (markers.length != 0) {
              for (var k = 1; k < markers.length; k++) {
                if (markers[k] != "") {
                  var existingMarker = markers[k];
                  var pos = existingMarker.getPosition();
                  if (latlng.equals(pos)) {
                    var a = 360.0 / markers.length;
                    var newLat =
                      pos.lat() +
                      -0.00025 * Math.cos(((+a * k) / 180) * Math.PI); //x
                    var newLng =
                      pos.lng() +
                      -0.00025 * Math.sin(((+a * k) / 180) * Math.PI); //Y
                    latlng = new google.maps.LatLng(newLat, newLng);
                  }
                }
              }
            }

            var marker = new google.maps.Marker({
              map: map,
              title: index.Name,
              position: latlng,
              icon: {
                url: index.ETLLoadID === etlid ? selectedIcon : unselectedIcon,
              },
            });
            map.setCenter(marker.getPosition());

            var infowindow = new google.maps.InfoWindow();

            /*marker.addListener("mouseover", function () {
              infowindow.open(map, this);
            });

            // assuming you also want to hide the infowindow when user mouses-out
            marker.addListener("mouseout", function () {
              infowindow.close();
            });*/

            google.maps.event.addListener(
              marker,
              "click",
              (function (marker, index, infowindow) {
                return function () {
                  const selectedIcon =
                    "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/map-pin-selected.svg";
                  const unselectedIcon =
                    "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/map-pin-unselected.svg";

                  for (var j = 0; j < markers.length; j++) {
                    markers[j].setIcon(unselectedIcon);
                  }

                  marker.setIcon(selectedIcon);
                  dispatch(ramactions.updateEtlID(index.ETLLoadID));
                  props.onMarkerClick("mp" + index.ETLLoadID);
                  resourcesmap.setZoom(zoomLevel);
                };
              })(marker, index, infowindow)
            );
            let markerExistingIcon;
            google.maps.event.addListener(marker, "mouseover", function () {
              //console.log(marker.icon.url);
              //markerExistingIcon = marker.icon.url;
              marker.setIcon(selectedIcon);
            });

            google.maps.event.addListener(marker, "mouseout", function () {
              marker.setIcon(unselectedIcon);
            });

            if (i < 10) {
              //console.log("In Map");
              bounds.extend({
                lat: parseFloat(index.Latitude),
                lng: parseFloat(index.Longitude),
              });
            }
            i = i + 1;

            markers.push(marker);
          }
        }
      }
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    });

    setAllmarkers(markers);
    if (resourcesmap !== undefined) resourcesmap.setZoom(zoomLevel);
  };

  const handleActiveMarker = (marker) => {
    //console.log(marker);
    const first = marker;
    const newResult = rearchresults.slice().sort(function (x, y) {
      return x.ETLLoadID == first ? -1 : y.ETLLoadID == first ? 1 : 0;
    });
    //console.log(newResult);
    dispatch(ramactions.addSearchresult(newResult));
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
    dispatch(ramactions.updateEtlID(marker));
  };

  const handleOnLoad = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    let i = 0;
    rearchresults.forEach((index) => {
      if (i < 10) {
        bounds.extend({
          lat: parseFloat(index.Latitude),
          lng: parseFloat(index.Longitude),
        });
      }
      i = i + 1;
    });
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  };

  var markerStyling = {
    clear: "both",
    display: "inline-block",
    backgroundColor: "#00921A",
    fontWeight: "500",
    color: "#FFFFFF",
    boxShadow: "0 6px 8px 0 rgba(63,63,63,0.11)",
    borderRadius: "23px",
    padding: "8px 16px",
    whiteSpace: "nowrap",
    width: "160px",
    textAlign: "center",
  };
  const mapzoomin = () => {
    //console.log(resourcesmap.getZoom() + 1);
    resourcesmap.setZoom(resourcesmap.getZoom() + 1);
    dispatch(ramactions.updateZoomLevel(resourcesmap.getZoom() + 1));
  };
  const mapzoomout = () => {
    //console.log(resourcesmap.getZoom() + 1);
    resourcesmap.setZoom(resourcesmap.getZoom() - 1);
    dispatch(ramactions.updateZoomLevel(resourcesmap.getZoom() - 1));
  };
  return (
    <>
      {totalphysical > 0 && (
        <Fragment>
          <Helmet>
            <script
              src={
                "https://maps.googleapis.com/maps/api/js?key=" +
                process.env.REACT_APP_GOOGLE_MAP_API_KEY +
                "&language=" +
                webLanguage +
                "&callback=initMap"
              }
              async
              defer
            />
          </Helmet>
          <div class="map__controls" id="map_controls">
            <ul id="map_controls_ul">
              <li class="map__controls--zoomIn" id="map_controls_zoomIn">
                <button onClick={mapzoomin} aria-label="zoom in"></button>
              </li>
              <li class="map__controls--zoomOut" id="map_controls_zoomOut">
                <button onClick={mapzoomout} aria-label="zoom out"></button>
              </li>
            </ul>
          </div>
          <div style={{ height: "100%" }} id="mapview"></div>
        </Fragment>
      )}
      {totalphysical === 0 && (
        <div className="no-map">
          <div className="text-content">{t("no_results")}</div>
        </div>
      )}
    </>
  );
};

export default Map;
